// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aec1ec3d","994":"f30dd703"}[chunkId] + ".chunk.js";
};